import { render } from "./PaymentSuccess.vue?vue&type=template&id=0e70efc4"
const script = {}

import exportComponent from "/Users/computerscience/Desktop/connect-dashboard/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__